export default {
  DEFAULT_FALLBACK_LANGUAGE: "en",
  DEFAULT_FALLBACK_BRAND: "bmw",
  DEFAULT_FALLBACK_CSS_REFERENCE: "default",
  SUPPORTED_BRANDS: ["bmw", "mini", "rr", "alphabet", "alphera", "bmwmotorrad", "toyota"],
  BASE_CONFIG_FILE_NAME: "baseConfig.json",
  FULL_WIDTH_PAGES: ["profile", "maintenance", "logout", "translations"],
  TIMEOUT_NOTIFICATIONS: 10000,
  TIMEOUT_NOTIFICATIONS_WITH_LINK: 20000,
  TIMEOUT_LOGOUT: 5000,
  ALL_SCOPES: "authenticate_user manage_credentials basic_profile full_profile manage_profile read parknow vehicle_events cesim remote_services openid smacc vehicle_data vehicle_list perseus dlm svds vsapi mini_connected fupo", 
  NOLOGINCLIENT: [
    'incar'
  ],
  THIRDPARTYAPI: [
    "TOLERANT",
    "HCAPTCHA"
  ],
  ESIMAPI: [
    "getCesimSubscription",
    "invalidateCesimSubscription",
    "getCesimCountries",
    "getCesimMnos",
    "getCesimRedirect",
  ],
  VISAPI: [
    "getVis",
  ],
  LINKED_SERVICES_SHOWING_SUBSCRIPTIONS_DELETE_SUBTITLE: [
    "CONNECTED_MAPPING",
    "CONNECTED_SUBSCRIBED"
  ],
  REGEXP: {
    //password rules
    LETTERS_REGEXP: /.*[a-zA-Z].*/,
    LOWER_LETTERS_REGEXP: /.*[a-z].*/,
    UPPER_LETTERS_REGEXP: /.*[A-Z].*/,
    NUMBER_REGEXP: /.*[\d].*/,
    SYMBOL_REGEXP: /.*[-./',;&@#*)(_+:"~].*/,
    ONLY_ALLOWED: /^[0-9a-zA-Z-./',;&@#*)(_+:"~]+$/,
    ONLY_NUMBERS: /^[\d]+$/,
    EMAIL_REGEXP: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
  }
};
